import type { InventoryResult } from '../api';

type InventoryStatus = 'planned' | 'in_progress' | 'closed';

const STATUS_CFG: Record<InventoryStatus, { label: string; className: string }> = {
  planned: { label: 'Planejado', className: 'bg-gray-100 text-gray-700' },
  in_progress: { label: 'Em andamento', className: 'bg-blue-100 text-blue-800' },
  closed: { label: 'Fechado', className: 'bg-green-100 text-green-800' },
};

const RESULT_CFG: Record<InventoryResult, { label: string; className: string }> = {
  pending: { label: 'Pendente', className: 'bg-gray-100 text-gray-700' },
  found: { label: 'Localizado', className: 'bg-green-100 text-green-800' },
  not_found: { label: 'Não localizado', className: 'bg-red-100 text-red-800' },
  divergent: { label: 'Divergente', className: 'bg-orange-100 text-orange-800' },
  damaged: { label: 'Danificado', className: 'bg-red-100 text-red-800' },
};

export function InventoryStatusBadge({ status }: { status: InventoryStatus }) {
  const cfg = STATUS_CFG[status];
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cfg.className}`}>
      {cfg.label}
    </span>
  );
}

export function InventoryResultBadge({ result }: { result: InventoryResult }) {
  const cfg = RESULT_CFG[result];
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cfg.className}`}>
      {cfg.label}
    </span>
  );
}

export const INVENTORY_STATUS_LABELS = Object.fromEntries(
  (Object.entries(STATUS_CFG) as Array<[InventoryStatus, { label: string }]>).map(([k, v]) => [k, v.label]),
) as Record<InventoryStatus, string>;

export const INVENTORY_RESULT_LABELS = Object.fromEntries(
  (Object.entries(RESULT_CFG) as Array<[InventoryResult, { label: string }]>).map(([k, v]) => [k, v.label]),
) as Record<InventoryResult, string>;
